import { Container } from './Container'
import { Gradient } from './Gradient'
import { Link } from './Link'
import { Logo } from './Logo'
import { PlusGrid, PlusGridItem, PlusGridRow } from './PlusGrid'

// Decision 8 — 4-column footer with mission tagline + "Founded by" line.
const columns = [
  {
    heading: 'Product',
    links: [
      { href: '/how-it-works', label: 'How It Works' },
      { href: '/security', label: 'Security' },
      { href: '/platform', label: 'Platform' },
      { href: '/pricing', label: 'Pricing' },
      { href: '/login', label: 'Login' },
    ],
  },
  {
    heading: 'Resources',
    links: [
      { href: '/faq', label: 'FAQ' },
      { href: '/status', label: 'Status' },
      { href: '/contact', label: 'Contact' },
      { href: '/enterprise', label: 'Enterprise' },
    ],
  },
  {
    heading: 'Legal',
    links: [
      { href: '/privacy', label: 'Privacy Policy' },
      { href: '/terms', label: 'Terms of Service' },
      { href: '/refunds', label: 'Refund Policy' },
    ],
  },
]

const FOUNDED_BY =
  "Founded by people who've reviewed compliance reports from the other side of the table — built for the operators who have to produce them."

function SitemapHeading({ children }: { children: React.ReactNode }) {
  return <h3 className="text-sm/6 font-medium text-gray-950/50">{children}</h3>
}

function SitemapColumn({
  heading,
  links,
}: {
  heading: string
  links: { href: string; label: string }[]
}) {
  return (
    <div>
      <SitemapHeading>{heading}</SitemapHeading>
      <ul className="mt-6 space-y-4 text-sm/6">
        {links.map(({ href, label }) => (
          <li key={href}>
            <Link
              href={href}
              className="font-medium text-gray-950 transition hover:text-gray-950/75"
            >
              {label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  )
}

export function Footer() {
  return (
    <footer>
      <Gradient className="relative">
        <div className="absolute inset-2 rounded-4xl bg-white/80" />
        <Container>
          <PlusGrid className="pt-16 pb-16">
            <PlusGridRow>
              <div className="grid grid-cols-2 gap-y-10 pb-6 lg:grid-cols-6 lg:gap-8">
                <div className="col-span-2 flex">
                  <PlusGridItem className="pt-6 lg:pb-6">
                    <Logo className="h-9" />
                    <p className="mt-6 max-w-xs text-sm/6 text-gray-700">
                      Vendor compliance, built like infrastructure.
                    </p>
                    <div className="mt-6 flex flex-wrap items-center gap-x-2 gap-y-1 text-xs font-medium text-gray-500">
                      <span>AWS infrastructure</span>
                      <span aria-hidden="true">·</span>
                      <span>Stripe payments</span>
                    </div>
                  </PlusGridItem>
                </div>
                <div className="col-span-2 grid grid-cols-2 gap-x-8 gap-y-12 sm:grid-cols-3 lg:col-span-4 lg:grid-cols-subgrid lg:pt-6">
                  {columns.map((column) => (
                    <SitemapColumn key={column.heading} {...column} />
                  ))}
                </div>
              </div>
            </PlusGridRow>
            <PlusGridRow>
              <PlusGridItem className="py-6">
                <p className="max-w-2xl text-sm/6 text-gray-600">{FOUNDED_BY}</p>
              </PlusGridItem>
            </PlusGridRow>
            <PlusGridRow className="flex justify-between">
              <PlusGridItem className="py-3">
                <div className="text-sm/6 text-gray-950">
                  © {new Date().getFullYear()} CertShieldPro · All rights
                  reserved
                </div>
              </PlusGridItem>
            </PlusGridRow>
          </PlusGrid>
        </Container>
      </Gradient>
    </footer>
  )
}
